import * as React from 'react';
import { MutationMode, RaRecord } from 'react-admin';
import { DeleteWithConfirmIconButton } from './DeleteWithConfirmIconButton';
import { DeleteWithUndoIconButton } from './DeleteWithUndoIconButton';

export const DeleteRowButton = ({
    mutationMode,
    ...rest
}: DeleteRowButtonProps) => {
    return mutationMode === 'undoable' ? (
        <DeleteWithUndoIconButton {...rest} />
    ) : (
        <DeleteWithConfirmIconButton mutationMode={mutationMode} {...rest} />
    );
};

export interface DeleteRowButtonProps {
    mutationMode?: MutationMode;
    record?: RaRecord;
    resource?: string;
}

export default DeleteRowButton;
